document.documentElement.classList.add('js');

const state = { product: 'ten', lastFocus: null };
const $ = id => document.getElementById(id);
const productDataElement = $('EskerProductData');
let products = {};
try { products = productDataElement ? JSON.parse(productDataElement.textContent) : {}; } catch (_) { products = {}; }

const announcement = $('announcement');
const dismissAnnouncement = $('dismissAnnouncement');
const siteHeader = $('siteHeader');
const menuButton = $('menuButton');
const mobileNav = $('mobileNav');
const drawer = $('purchaseDrawer');
const drawerScrim = $('drawerScrim');
const drawerClose = $('drawerClose');
const checkoutButton = $('checkoutButton');
const drawerNote = $('drawerNote');
const drawerStatus = $('drawerStatus');

function updateHeader() {
  siteHeader?.classList.toggle('scrolled', window.scrollY > 16);
}

function closeMenu() {
  if (!mobileNav || !menuButton) return;
  mobileNav.hidden = true;
  menuButton.classList.remove('active');
  menuButton.setAttribute('aria-expanded', 'false');
  menuButton.setAttribute('aria-label', 'Open navigation');
  document.body.classList.remove('menu-open');
}

menuButton?.addEventListener('click', () => {
  const opening = mobileNav.hidden;
  mobileNav.hidden = !opening;
  menuButton.classList.toggle('active', opening);
  menuButton.setAttribute('aria-expanded', String(opening));
  menuButton.setAttribute('aria-label', opening ? 'Close navigation' : 'Open navigation');
  document.body.classList.toggle('menu-open', opening);
});

mobileNav?.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
dismissAnnouncement?.addEventListener('click', () => { announcement.hidden = true; });

function updateDrawer() {
  const product = products[state.product];
  if (!product) return;
  $('drawerTitle').textContent = product.title;
  $('drawerProductName').textContent = product.name;
  $('drawerPerCup').textContent = product.perCup;
  $('drawerUnitPrice').textContent = product.price;
  $('drawerImage').src = product.image;
  $('drawerImage').alt = `Esker Coffee ${product.name}`;
  if (drawerStatus) { drawerStatus.textContent = ''; drawerStatus.classList.remove('error'); }

  if (!product.configured) {
    checkoutButton.disabled = true;
    checkoutButton.textContent = 'Connect this product in the theme editor';
    drawerNote.textContent = 'Choose the matching Shopify product in Customize → Homepage → Esker Version 8 homepage.';
  } else if (!product.available) {
    checkoutButton.disabled = true;
    checkoutButton.textContent = 'Currently unavailable';
    drawerNote.textContent = 'This product is connected, but its selected variant is not currently available.';
  } else {
    checkoutButton.disabled = false;
    checkoutButton.textContent = `Add to cart — ${product.price}`;
    drawerNote.textContent = 'Quantity, delivery details and payment are handled securely by Shopify.';
  }
}

function openDrawer(productKey, trigger) {
  if (!products[productKey] || !drawer || !drawerScrim) return;
  state.product = productKey;
  state.lastFocus = trigger || document.activeElement;
  updateDrawer();
  drawerScrim.hidden = false;
  drawer.removeAttribute('inert');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('drawer-open');
  requestAnimationFrame(() => {
    drawer.classList.add('open');
    drawerClose?.focus();
  });
}

function closeDrawer() {
  if (!drawer || !drawerScrim) return;
  drawer.classList.remove('open');
  document.body.classList.remove('drawer-open');
  drawer.setAttribute('aria-hidden', 'true');
  window.setTimeout(() => {
    drawer.setAttribute('inert', '');
    drawerScrim.hidden = true;
    state.lastFocus?.focus?.();
  }, 320);
}

document.querySelectorAll('[data-open-product]').forEach(button => {
  button.addEventListener('click', () => openDrawer(button.dataset.openProduct, button));
});

drawerClose?.addEventListener('click', closeDrawer);
drawerScrim?.addEventListener('click', closeDrawer);

checkoutButton?.addEventListener('click', async () => {
  const product = products[state.product];
  if (!product?.variantId || !product.available) return;
  checkoutButton.disabled = true;
  checkoutButton.textContent = 'Adding…';
  try {
    const response = await fetch(window.eskerRoutes?.cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: product.variantId, quantity: 1 }] })
    });
    if (!response.ok) throw new Error('Could not add product');
    window.location.href = window.eskerRoutes?.cart || '/cart';
  } catch (_) {
    checkoutButton.disabled = false;
    checkoutButton.textContent = `Add to cart — ${product.price}`;
    if (drawerStatus) {
      drawerStatus.textContent = 'That did not go through. Please try again.';
      drawerStatus.classList.add('error');
    }
  }
});

function trapDrawerFocus(event) {
  if (!drawer?.classList.contains('open') || event.key !== 'Tab') return;
  const focusable = [...drawer.querySelectorAll('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])')]
    .filter(el => !el.disabled && el.offsetParent !== null);
  if (!focusable.length) return;
  const first = focusable[0];
  const last = focusable.at(-1);
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault(); last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault(); first.focus();
  }
}

document.addEventListener('keydown', event => {
  if (event.key === 'Escape') {
    if (drawer?.classList.contains('open')) closeDrawer();
    else if (mobileNav && !mobileNav.hidden) closeMenu();
  }
  trapDrawerFocus(event);
});

const revealObserver = 'IntersectionObserver' in window
  ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -45px' })
  : null;

document.querySelectorAll('.reveal').forEach((element, index) => {
  element.style.transitionDelay = `${Math.min(index % 4, 3) * 55}ms`;
  if (revealObserver) revealObserver.observe(element);
  else element.classList.add('visible');
});

window.addEventListener('scroll', updateHeader, { passive: true });
window.addEventListener('resize', () => { if (window.innerWidth > 900) closeMenu(); });
updateHeader();
